
$( document ).ready(function() {
        var  mn = $(".bottom-header");
    mns = "main-nav-scrolled";
    hdr = $('header').height();

    $(window).scroll(function() {
      if( $(this).scrollTop() > (hdr - 56) ) {
        mn.addClass(mns);
        $('header').css('margin-bottom','56px');
      } else {
        mn.removeClass(mns);
        $('header').css('margin-bottom','0px');
      }
   });
  $('.widget-title i').click(function(){
  	$('.categories-inner-page').slideToggle();
  });

      
  $('.t-tabs li').click(function(){
        $('.t-tabs li').removeClass("active");
        $(this).addClass("active");
        var div_show = $(this).data('id');
        $('.tab').fadeOut('400');
        $('#'+div_show).stop().fadeIn('600');
    });
  
 });
